import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/locationgcc/dubai_new/teemates_back.webp";
import { StaticImage } from "gatsby-plugin-image";

function Teematescasedubai() {
  return (
    <section className="teemates_case_dubai p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              What Makes Us the Best Mobile App Development Company in Dubai?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We’ve been building smart, performant Android and iPhone mobile
              applications in Dubai for 8+ years. Combining this experience with
              novel frontend and backend technologies, our mobile app
              development company in Dubai has helped business from diverse
              backgrounds including FinTech, Healthcare, Gaming, Food Delivery,
              and Automotive. Our diverse team of Android app developers and iOS
              app developers in Dubai has keen and consistent focus on appealing
              UI/UX design, easy to user frontend development, adequate backend
              integration, and seamless app marketplace rollout – making your
              mobile app launch a success in UAE.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <StaticImage
              src="../../images/locationgcc/dubai_new/case_img.webp"
              alt="mobile app development company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1600}
              height={1246}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Teematescasedubai;
